import '!ng-cache-loader!./ForbiddenUserAlert.html';
import * as angular from 'angular';
import foldToASCII from 'data/foldToASCII';
import { MARKETPLACE_OPENED } from 'modules/application/marketplace/MarketplaceFeatures';
import './ListMarketplace.scss';
export const ON_SEARCH_EVENT = 'OnSeachEvent';
export class ListMarketplaceController {
    static $inject = ['$rootScope', 'MarketplaceService', 'LoadingService', 'ngToast', '$translate', '$stateParams', 'SegmentService', 'AccountService2'];
    constructor($rootScope, MarketplaceService, LoadingService, ngToast, $translate, $stateParams, SegmentService, AccountService2) {
        'ngInject';
        this.$rootScope = $rootScope;
        this.MarketplaceService = MarketplaceService;
        this.LoadingService = LoadingService;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.SegmentService = SegmentService;
        this.AccountService2 = AccountService2;
        this.defaultNotFoundMessage = 'marketplace.listView.noneRegistered';
        this.noSearchResultsMessage = 'marketplace.listView.templateNotFound';
        this.plan = '';
        this.showUpgradeModal = false;
        this.planAccount = '';
        this.selectedPlan = '';
        this.onChangeSearchPlan = (event) => {
            this.selectedPlan = event?.detail?.value;
            this.filtro();
        };
        this.onSearchLanguage = (event) => {
            this.searchLanguage = event?.detail?.value;
            this.filtro();
        };
        this.filtro = async () => {
            this.noSearchResults = false;
            if (!this.templatesBuffer) {
                this.templatesBuffer = angular.copy(this.templates);
            }
            if (this.searchLanguage) {
                const searchResults = this.templatesBuffer.filter((x) => {
                    const language = x.language ? x.language : 'pt-BR';
                    return foldToASCII(language)
                        .toLowerCase()
                        .includes(this.searchLanguage.toLowerCase());
                });
                if (searchResults.length > 0) {
                    this.templates = searchResults;
                    this.searchResults = undefined;
                }
                else {
                    this.templates = [];
                }
            }
            else {
                this.templates = this.templatesBuffer;
                this.templatesBuffer = undefined;
            }
            this.searchedPlans = await this.getSearchedPlans();
            const searchResults = this.templates.filter((x) => {
                const plans = x.plans != undefined ? x.plans : '00892f5b-0404-40d5-8c1f-a57b7f709877';
                return this.searchedPlans.includes(plans);
            });
            if (searchResults.length > 0) {
                this.templates = searchResults;
                this.searchResults = undefined;
            }
            else {
                this.templates = [];
            }
        };
        this.noSearchResults = false;
        this.$rootScope.$on(ON_SEARCH_EVENT, (_, text) => this.onSearchTemplates(text));
    }
    get notFoundMessage() {
        return this.noSearchResults
            ? this.noSearchResultsMessage
            : this.defaultNotFoundMessage;
    }
    closeUpgradePlan() {
        this.plan = '';
    }
    async $onInit() {
        this.LoadingService.startLoading(false);
        try {
            await this.loadPlan();
            await this.bindAllTemplates();
            await this.createTracking();
            this.planAccount = await (await this.AccountService2.getActiveSubscription()).planId;
        }
        catch (e) {
            console.error(e);
            const errorMsg3 = await this.$translate('utils.errorMsg.3');
            this.ngToast.danger(errorMsg3);
        }
        finally {
            this.LoadingService.stopLoading();
        }
    }
    async loadPlan() {
        this.plans = await this.MarketplaceService.getPlans();
    }
    async createTracking() {
        if (this.$stateParams?.from) {
            const accountId = (await this.AccountService2.me()).identity;
            this.SegmentService.createTrack(MARKETPLACE_OPENED, {
                source: this.$stateParams?.from,
                clientId: accountId,
            });
        }
    }
    async bindAllTemplates() {
        this.templates = await this.MarketplaceService.getTemplates();
        this.searchLanguage = (await this.AccountService2.me()).culture;
    }
    async getSearchedPlans() {
        const plans = await this.MarketplaceService.getPlans();
        if (this.selectedPlan) {
            const selected = plans.filter(plan => plan.value == this.selectedPlan)[0];
            return plans.filter(plan => plan.order <= selected.order).map(a => a.value);
        }
        else {
            return plans.map(a => a.value);
        }
    }
    onSearchTemplates(text) {
        const searchText = foldToASCII(text).toLowerCase();
        this.searchText = text;
        this.noSearchResults = false;
        if (!this.templatesBuffer) {
            this.templatesBuffer = angular.copy(this.templates);
        }
        if (searchText.length > 2) {
            const searchResults = this.templatesBuffer.filter((x) => foldToASCII(x.name)
                .toLowerCase()
                .includes(searchText));
            if (searchResults.length > 0) {
                this.templates = searchResults;
                this.searchResults = undefined;
            }
            else {
                this.templates = [];
                this.noSearchResults = true;
            }
        }
        else {
            this.templates = this.templatesBuffer;
            this.templatesBuffer = undefined;
        }
    }
}
ListMarketplaceController.$inject = ['$rootScope', 'MarketplaceService', 'LoadingService', 'ngToast', '$translate', '$stateParams', 'SegmentService', 'AccountService2'];
